<template>
  <span >
    <span>
      <v-tooltip bottom>
        <v-btn slot="activator" dark icon small flat @click.native="dialog = !dialog">
          <svg class="customIcon i_action"  viewBox="0 0 24 24">
              <path fill="#000000" d="M17,14H19V17H22V19H19V22H17V19H14V17H17V14M12,17V15H7V17H12M17,11H7V13H14.69C13.07,14.07 12,15.91 12,18C12,19.09 12.29,20.12 12.8,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19A2,2 0 0,1 21,5V12.8C20.12,12.29 19.09,12 18,12L17,12.08V11M17,9V7H7V9H17Z" />
          </svg>
        </v-btn>
        <span>Visualizar Inf. Estruturadas</span>
      </v-tooltip>
    </span>

    <v-layout row justify-center>
      <v-dialog
        @keydown.esc="dialog = false"
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark class="headline darkBlue">
            <v-toolbar-title>Informações da {{component.text}} - {{component.tipo.charAt(0).toUpperCase() + component.tipo.slice(1)}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="printInfos()">
              <v-icon>print</v-icon>
            </v-btn>

            <v-btn icon dark @click.native="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <article class="view_indo_nfse" :id="`infoBody_${this.nota._id}`">
            <v-list three-line subheader>
              <!-- {{forn}} -->
              <v-subheader>
                <h2>{{component.text}}:</h2>
              </v-subheader>
              <v-layout row wrap>
                <v-flex
                  :class="[headers.value == 'discriminacao' ? 'flex xs12 sm12 md12 xl12' : 'flex xs6 sm3 md3 xl3']"
                  v-for="(headers,i) in table.headers"
                  :key="i"
                  v-if="headers.show && headers.enable && headers.value.indexOf('custom_') == -1"
                >
                  <v-list-tile
                    avatar
                    :class="[headers.value == 'discriminacao' ? 'altura_maior' : '']"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title style="padding-bottom: 20px;">{{headers.text}}:</v-list-tile-title>
                      <v-list-tile-sub-title :id="headers.value">
                        <span
                          class="fundo_destaque"
                          v-if="headers.value.indexOf('dt') != -1"
                        >{{nota[headers.value] ? nota[headers.value].toLocaleDateString() : ''}}</span>
                        <span
                          class="fundo_destaque"
                          v-else-if="headers.value.indexOf('vlr') != -1"
                        >{{nota[headers.value] ? nota[headers.value].toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) : ''}}</span>
                        <span
                          class="fundo_destaque"
                          v-else-if="headers.value.indexOf('tribNfe') != -1"
                        >{{tributacao ? `${tributacao.tipo} - ${tributacao.desc}` : ''}}</span>
                        <span
                          class="fundo_destaque"
                          v-else-if="headers.value.indexOf('opcaoSimples') != -1"
                        >{{simples ? `${simples.tipo} - ${simples.desc}` : ''}}</span>
                        <span
                          class="fundo_destaque"
                          v-else-if="headers.value.indexOf('ISSRetido') != -1"
                        >{{nota[headers.value] ? nota[headers.value] == 'true' ? 'Sim' : 'Não' : ''}}</span>
                        <span
                          class="fundo_destaque"
                          v-else-if="headers.value.indexOf('vlr') != -1"
                        >{{nota[headers.value] ? nota[headers.value].toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) : ''}}</span>
                        <span
                          class="fundo_destaque"
                          v-else-if="headers.value.indexOf('cnpj') != -1"
                        >{{nota[headers.value] ? nota[headers.value].length == 14 ? nota[headers.value].replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : nota[headers.value].replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : ''}}</span>
                        <span class="fundo_destaque" v-else>{{nota[headers.value]}}</span>

                      </v-list-tile-sub-title>
                      <v-list-tile-sub-title></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
              </v-layout>
            </v-list>
            <v-divider></v-divider>
            <v-list three-line subheader>
              <v-subheader>
                <h2>Dados customizados:</h2>
              </v-subheader>
              <v-layout row wrap>
                <v-flex
                  xs6
                  sm3
                  md3
                  xl3
                  v-for="(item,i) in nota"
                  :key="item._id"
                  v-if="i.indexOf('custom_') != -1 && item.value != null && item.value.length > 0"
                >
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title style="text-transform: capitalize;">{{nomeColumn(i)}}:</v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span class="fundo_destaque">{{item.value}}</span>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
                <v-flex xs6 sm3 md3 xl3 v-if="noDataText">
                  <v-list-tile avatar>
                    <v-list-tile-content>
                      <v-list-tile-title
                        style="text-transform: capitalize;"
                      >Não possui informações customizadas.</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
              </v-layout>
            </v-list>
          </article>
        </v-card>
      </v-dialog>
    </v-layout>
  </span>
</template>
<script>
import { findTributacao, findSimples } from "@/domain/notas/nfse/util";
export default {
  props: ["nota", "table", "component"],
  updated: function() {
    this.$nextTick(function() {});
  },
  beforeMount() {},
  data: () => ({
    dialog: false,
    notifications: false,
    sound: false,
    widgets: false,
    noDataText: true,
    tributacao: null,
    simples: null
  }),
  watch: {
    dialog: function(newV, oldV) {
      this.noDataText = true;
    }
  },
  components: {},
  mounted: async function() {
    this.$nextTick(async function() {
      findTributacao(this.nota.tribNfe).then(res => {
        this.tributacao = res;
      });
      findSimples(this.nota.opcaoSimples).then(res => {
        this.simples = res;
      });
    });
  },
  methods: {
    printInfos: function() {
      var conteudo = document.getElementById(`infoBody_${this.nota._id}`)
          .innerHTML,
        tela_impressao = window.open("Motor Fiscal");
      tela_impressao.document.write(
        `<html><head><title>Motor Fiscal - ${this.component.text}</title>`
      );
      tela_impressao.document.write(
        `<style>html,body {margin: 0;padding: 0;border: 0;}.v-list__tile__content {text-align: left;flex: 1 1 auto;overflow: hidden;display: flex;align-items: flex-start;justify-content: center;flex-direction: column;}.v-list__tile__title {font-weight: bold;height: 24px;line-height: 24px;position: relative;text-align: left;}.fundo_destaque {background-color: whitesmoke;padding-left: 10px;}.flex.md3 {flex-basis: 25%;flex-grow: 0;max-width: 25%;}.flex.xs6 {flex-basis: 50%;flex-grow: 0;max-width: 50%;}.child-flex > *,.flex {flex: 1 1 auto;max-width: 100%;}.layout.wrap {flex-wrap: wrap;}   .layout.row {flex-direction: row;}.layout {display: flex;flex: 1 1 auto;flex-wrap: nowrap;min-width: 0;}</style>`
      );
      tela_impressao.document.write("</head><body >");
      tela_impressao.document.write(conteudo);
      tela_impressao.document.write("</body></html>");

      tela_impressao.window.print();
      tela_impressao.window.close();
      //   #infoBody
    },

    nomeColumn: function(i) {
      let nomeColumn = "";
      this.table.headers.forEach(element => {
        if (element.value == i) {
          nomeColumn = element.text;
        }
      });
      if (nomeColumn != "") {
        this.noDataText = false;
      }
      return nomeColumn;
    }
  }
};
</script>
<style>
.vinculoChip span.v-chip__content {
  cursor: pointer;
  font-size: 10px !important;
}
.fundo_destaque {
  background-color: whitesmoke;
  padding: 5px;
}
.view_indo_nfse #discriminacao {
  padding-bottom: 24px;
  white-space: pre-line;
  word-wrap: break-word;
  overflow: unset;
  overflow-y: scroll;
  height: 104px;
  padding-right: 20px;
  font-size: 12px;
}
.altura_maior .v-list__tile.v-list__tile--avatar{
  height: 213px!important;
}
</style>
  



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_actions/btnInfNfses/btnInfNfses.vue